<template>
  <div class="schedule" v-track="{ act: 'ready', data: { id: 368 } }">
    <div class="schedule-wrap">
      <my-header showBack>
        <div slot="title">{{ cinemaName }}</div>
      </my-header>
      <!-- 消息通知 -->
      <NoticeMessage :noticeMsg="schedule.noticeMsg" :filmLimit="filmLimit" v-show="schedule.noticeMsg" />
      <div class="notice-padding" v-show="!schedule.noticeMsg"></div>
      <!-- 分区定价类目 -->
      <section-category :sectionCategories="sectionPrices" :sectionMap="sectionMap" v-if="isSupportSectionPrice" />
      <!-- 小地图 -->
      <Minimap v-if="!!isShowMinimap" :score="bmScore" />
      <!-- 座位图 -->
      <seating-chart :id="id" :authType="authType" :style="{ top: '118px' }" :isResetSeats="isResetSeats" />
      <!-- 座位状态说明 -->
      <SeatStatusTips />

      <div class="action-container">
        <div class="input-wrap">
          <!-- 实名认证 -->
          <template v-if="seats">
            <div class="realname-box" @click="toRealName" v-show="!realnameIsFull && authType != 1">
              <img src="../../../image/schedule/card.png" alt />
              <span class="title">请进行实名登记</span>
              <!-- <span class="need" v-show="authType == 3">还需{{ count - selectPeopleCount }}个座位实名信息</span> -->
              <span class="need" v-show="authType == 3">{{ selectPeopleNames }}</span>
              <Icon :size="12" color="#797D82">quanju_liebiaojiantou</Icon>
            </div>
            <div class="realname-box" @click="toRealName" v-show="realnameIsFull && authType != 1">
              <img src="../../../image/schedule/done.png" alt />
              <span class="title-done">已完成实名登记</span>
              <span class="need-done">{{ selectPeopleNames }}</span>
              <Icon :size="12" color="#797D82">quanju_liebiaojiantou</Icon>
            </div>
          </template>

          <!-- 选座信息 -->
          <div class="cinema-wrap">
            <div class="cinema-info">
              <div class="film-name">{{ filmName }}</div>
              <div class="film-des">{{ filmDes }}</div>
              <span class="switch" @click="onSwitchSchedule">
                {{ isSwitching ? '收起场次' : '切换场次' }}
                <img
                  class="arrow"
                  src="../../../image/schedule/icon_right_arrow_v2@2x.png"
                  :style="{ transform: `rotate(${isSwitching ? '180deg' : '0deg'})` }"
                  alt
                />
              </span>
              <!-- 排期列表 -->
              <schedule-list :defaultSchduleId="id" :schedules="schedules" :isSwitching="isSwitching" @scheduleChange="onScheduleChange" v-show="isSwitching" />
            </div>
            <!-- 已选座位 -->
            <select-seats :selectedSeats="selectedSeats" @cancelSeat="onCancelSelectSeat" v-if="isShowSelectSeats" />
          </div>
        </div>
      </div>

      <confirm-btn :text="confirmMsg" :realnameIsFull="realnameIsFull" @handleConfirm="confirm" v-track="{ act: 'click', data: { id: 370 } }"></confirm-btn>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import { MessageBox, Toast } from 'mint-ui'
import * as R from 'ramda'
import moment, { min } from 'moment'
import _ from 'underscore'

import { myIndicator } from '../../components/my-indicator'
import { isLogged, toLogin, toYuan, getHostName, isMobile } from '../../util/function'
import { getSectionMap, getSeatPrice } from '@util/schedule'
import cookie from '../../lib/cookie'
import CCONSTANT from '../../constant/cookie'
import CONSTANT from '../../constant/preorder'
import ScheduleConstant from '@con/schedule'
import Header from '../../components/header'
import Icon from '../../components/icon'
import SeatingChart from './subview/seating_chart'
import ConfirmBtn from './subview/confirm_btn'
import MobileInput from './subview/mobile_input'
import Minimap from './subview/minimap'
import op from 'object-path'
import bm from '../../util/benchmark'
import validator from '../../util/validator/seat'
import ScheduleService from '../../service/schedule'
import ScheduleList from './subview/schedule-list'
import SelectSeats from './subview/select-seats'
import SectionCategory from './subview/section-category'
import SeatStatusTips from './subview/seat-status-tips'
import NoticeMessage from './subview/notice-message'

const UNPAID_TITLE = '您还有一笔未付款订单，是否需要帮您取消？'
const GOPAY = '去支付'
const CANCELORDER = '取消旧订单'
const MSGBOXTITLE = '提示'
const INVALIDMOBILE = '请输入正确的11位手机号'
const cancelOrderClass = ''

var MINIMAP_MIN_BUFU_SCORE = 8000
//实名认证规则
const REALNAME_AUTH_TYPE_NOT_NEED = 1 //不校验
const REALNAME_AUTH_TYPE_ONE = 2 //一单一认证
const REALNAME_AUTH_TYPE_ALL = 3 //一座一认证

const checkoutUrl = orderId => {
  return `${getHostName()}/v5/#/preorder/${orderId}?type=${CONSTANT.PREORDER_TYPE_IS_SEAT_TICKET}`
}

const bmScore = bm.run().score

export default {
  data() {
    return {
      id: this.$route.params.id,
      // 当前选择日期
      currentDate: this.$route.params.date,
      bmScore: bmScore,
      isShowMinimap: bmScore - MINIMAP_MIN_BUFU_SCORE > 0,
      fromRoute: '',
      // 是否正在切换场次
      isSwitching: false,
    }
  },
  components: {
    'my-header': Header,
    'seating-chart': SeatingChart,
    'confirm-btn': ConfirmBtn,
    'mobile-input': MobileInput,
    Minimap,
    Icon,
    'schedule-list': ScheduleList,
    'select-seats': SelectSeats,
    'section-category': SectionCategory,
    SeatStatusTips,
    NoticeMessage,
  },
  methods: {
    ...mapActions(['getScheduleDetail', 'getScheduleSeatChart', 'createPreorder', 'getUnpaidPreorder', 'cancelPreorder', 'getScheduleList']),
    confirm() {
      // check has unpaid preorder.
      if (this.unpaidOrderId) {
        return MessageBox({
          title: MSGBOXTITLE,
          message: UNPAID_TITLE,
          showCancelButton: true,
          cancelButtonText: GOPAY,
          confirmButtonText: CANCELORDER,
          confirmButtonClass: 'schedule-cancel-order',
        }).then(action => {
          if (action === 'cancel') {
            return this.$router.push({
              path: `/preorder/${this.unpaidOrderId}?type=${CONSTANT.PREORDER_TYPE_IS_SEAT_TICKET}`,
            })
          }
          return this.cancelPreorder(this.unpaidOrderId)
            .then(
              () => {
                return this.getScheduleSeatChart(this.id)
              },
              e => {
                return Toast({
                  message: e,
                  position: 'bottom',
                  duration: 3000,
                })
              },
            )
            .then(null, e => {
              MessageBox(MSGBOXTITLE, e)
            })
            .finally(myIndicator())
        })
      }
      const orderInfo = {
        scheduleId: +this.id,
        seats: this.seats,
        count: +this.count,
        price: +this.price,
        mobile: this.phoneNum,
        seatList: this.orderSeatList,
        realNameAuth: {
          realNameList: this.selectPeopleList,
        },
      }
      //是否使用前端校验
      // 检查座位是否符合条件
      if (this.ruleCheckType == 1) {
        const s = this.$store.state.preorder.seats
        const weak = validator.weak()(this.allSeats, s)
        const maxLine = validator.maxLine()(this.allSeats, s)
        if (weak) {
          return Toast({
            message: weak,
            position: 'bottom',
            duration: 3000,
          })
        }
        if (maxLine) {
          return Toast({
            message: maxLine,
            position: 'bottom',
            duration: 3000,
          })
        }
      }

      this.createPreorder(orderInfo)
        .then(order => {
          return this.$router.push({
            path: `/preorder/${order.orderId}?type=${CONSTANT.PREORDER_TYPE_IS_SEAT_TICKET}`,
          })
        })
        .catch(e => {
          MessageBox(MSGBOXTITLE, e)
        })
        .finally(myIndicator())
    },
    // hardcode for all browser reload this page after redirect to confirm page.
    autoRefresh() {
      setTimeout(() => {
        window.location.reload()
      }, 1000)
    },
    toRealName() {
      const ids = []
      this.selectPeopleList.map(v => {
        ids.push(v.infoId)
      })
      this.$router.push({
        path: '/realname/list',
        query: {
          seatcount: this.count,
          infoIds: ids.join(','),
          authType: op(this.schedule).get('realNameAuth.authType') || 1,
        },
      })
    },
    onSwitchSchedule() {
      this.isSwitching = !this.isSwitching
    },
    onScheduleChange(scheduleId) {
      // 重置已选座位
      this.$store.commit(CONSTANT.PREORDER_RESET_SEATS)
      this.getScheduleDetail(scheduleId).then(({ detail }) => {
        // 必须在同步排期详情后再更改 id
        this.id = scheduleId
        this.showCinemaNoticeDialog(detail)
      })
      this.getScheduleSeatChart(scheduleId)
        .then(null, e => {
          MessageBox(MSGBOXTITLE, e)
        })
        .finally(myIndicator())
    },
    // 取消已选座位
    onCancelSelectSeat(targetSeat) {
      const targetColumnNum = +targetSeat.columnNum
      const targetRowNum = +targetSeat.rowNum
      const filterSeats = this.getPreorderSelectedSeats.filter(seat => {
        const columnNum = +seat.columnNum
        const rowNum = +seat.rowNum
        // 当前点击
        const isCurrent = targetColumnNum === columnNum && targetRowNum === rowNum
        // 处理情侣座
        // 情侣座左侧座位
        if (targetSeat.coupleType === 1) {
          const isRight = targetColumnNum + 1 === columnNum && targetRowNum === rowNum
          return !isCurrent && !isRight
        }
        // 情侣座右侧座位
        if (targetSeat.coupleType === 2) {
          const isLeft = targetColumnNum - 1 === columnNum && targetRowNum === rowNum
          return !isCurrent && !isLeft
        }
        return !isCurrent
      })
      this.$store.commit(CONSTANT.PREORDER_SET_SEATS, filterSeats)
    },
    showCinemaNoticeDialog(scheduleDetail) {
      if (_.isEmpty(scheduleDetail) || !this.isResetSeats) {
        return
      }
      const notice = scheduleDetail.cinema.notice
      if (!notice) {
        return
      }
      MessageBox({
        title: '温馨提示',
        message: notice,
        confirmButtonText: '我知道了',
      })
    },
  },
  computed: {
    ...mapGetters(['getScheduleDetailById', 'getScheduleListByKey', 'getPreorderSelectedSeats']),
    ...mapState({
      unpaidOrderId: state => state.preorder.unpaidOrderId,
      seatingChart: state => state.schedule.seatingChart,
      count: state => op(state).get('preorder.seats.length') || 0,
      mobileValue: state => state.preorder.mobile || '',
      allSeats: state => {
        return R.path(['schedule', 'seatingChart', 'seats'], state) || []
      },
      selectPeopleList: state => state.realname.selectList,
      selectPeopleCount: state => op(state).get('realname.selectList.length') || 0,
      selectedScheduleId: state => state.schedule.selectedScheduleId,
    }),
    phoneNum() {
      return this.$store.state.preorder.mobile || ''
    },
    confirmMsg() {
      let ret = ['请先选座', '确认选座']
      const sum = this.totalPrice
      let price = sum ? toYuan(sum) + '元 ' : ''
      return price + (price ? ret[1] : ret[0])
    },
    // 计算总价
    totalPrice() {
      return this.selectedSeats.reduce((acc, seat) => {
        return acc + seat.seatPrice
      }, 0)
    },
    seats() {
      const s = this.selectedSeats
      const sortedS = R.compose(
        R.join('|'),
        R.map(seat => {
          return R.join(':')([seat.rowId, seat.columnId])
        }),
      )(s)
      return sortedS || ''
    },
    orderSeatList() {
      return this.selectedSeats.map(seat => {
        return {
          offerSeatId: seat.offerSeatId,
        }
      })
    },
    price() {
      // 目前不能跨区选择，所以所有已选的座位价格都一致
      return op.get(this.selectedSeats, '0.seatPrice') || 0
    },
    // 当前排期信息
    schedule() {
      return this.getScheduleDetailById(this.id)
    },
    // 排期列表
    schedules() {
      if (_.isEmpty(this.schedule)) {
        return []
      }
      const { cinema, film } = this.schedule
      const k = String(film.filmId) + String(cinema.cinemaId) + String(this.currentDate)
      return this.getScheduleListByKey(k)
    },
    cinemaName() {
      return R.path(['cinema', 'name'])(this.schedule) || '影院'
    },
    filmName() {
      return R.path(['film', 'name'])(this.schedule) || '电影'
    },
    filmDes() {
      const schedule = this.schedule
      if (R.isEmpty(schedule)) {
        return ''
      }
      const ret = moment.unix(schedule.showAt).format('dddMM月DD日 HH:mm ') + (R.path(['film', 'language'])(schedule) || '') + (schedule.imagery || '')
      return ret
    },
    filmLimit() {
      return R.path(['hall', 'limit'], this.seatingChart) || ''
    },
    needRealNameCount() {
      switch (+this.authType) {
        case REALNAME_AUTH_TYPE_ONE:
          return 1
        case REALNAME_AUTH_TYPE_ALL:
          return this.count
        case REALNAME_AUTH_TYPE_NOT_NEED:
        default:
          return 0
      }
    },
    realnameIsFull() {
      // needRealNameCount 需要认证的座位数，selectPeopleCount 已实名认证数
      return this.needRealNameCount === this.selectPeopleCount
    },
    authType() {
      // authType 1  不验证 2 一单一验证 3 一座一验证
      return op(this.schedule).get('realNameAuth.authType') || 1
    },
    isResetSeats() {
      return this.fromRoute !== 'realNameList'
    },
    ruleCheckType() {
      return op(this.schedule).get('lockSeatRules.ruleCheckType') || 1
    },
    selectPeopleNames() {
      return this.selectPeopleList.map(person => person.name).join(',')
    },
    // 是否支持分区定价
    isSupportSectionPrice() {
      return this.sectionPrices.length > 1
    },
    sectionPrices() {
      return op.get(this.schedule, 'sectionPrices') || []
    },
    // 分区定价哈希表，以 sectionId 为 key
    sectionMap() {
      return getSectionMap(this.seatingChart, this.sectionPrices)
    },
    // ！注意，这是基于已选座位的深拷贝，添加了座位价格，有涉及对座位图表的操作不能使用该对象
    selectedSeats() {
      if (_.isEmpty(this.getPreorderSelectedSeats) || _.isEmpty(this.sectionMap)) {
        return []
      }

      const target = R.clone(this.getPreorderSelectedSeats).map(item => {
        item.seatPrice = getSeatPrice(item, this.sectionMap)
        return item
      })
      return target
    },
    isShowSelectSeats() {
      return !_.isEmpty(this.selectedSeats)
    },
  },

  async mounted() {
    if (!isLogged()) {
      return toLogin()
    }
    await ScheduleService.checkLogin()

    // 从实名登记页返回读取已选场次 id
    if (this.selectedScheduleId) {
      this.id = this.selectedScheduleId
    }

    this.getScheduleDetail(this.id).then(({ detail }) => {
      const { film, cinema } = detail
      // 获取排期列表
      this.getScheduleList({
        filmId: film.filmId,
        cinemaId: cinema.cinemaId,
        date: this.currentDate,
      }).catch(err => {
        console.error(err)
      })
      this.showCinemaNoticeDialog(detail)
    })
    this.getScheduleSeatChart(this.id)
      .then(null, e => {
        MessageBox(MSGBOXTITLE, e)
      })
      .finally(myIndicator())
    this.getUnpaidPreorder()
    const mobile = cookie(CCONSTANT.COOKIE_USER_MOBILE)
    if (this.mobileValue || mobile) {
      this.$store.commit(CONSTANT.PREORDER_SET_MOBILE, this.mobile || mobile)
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.fromRoute = from.name
      if (from.name !== 'realNameList') {
        vm.$store.commit('clearSelectList')
      }
    })
  },
  beforeRouteLeave(to, from, next) {
    if (to.name === 'realNameList') {
      // 去往实名页时缓存已选场次 id
      this.$store.commit(ScheduleConstant.SCHEDULE_SET_SELECT_ID, this.id)
    } else {
      // 否则清除已选 id
      this.$store.commit(ScheduleConstant.SCHEDULE_SET_SELECT_ID, null)
      // 重置已选座位
      this.$store.commit(CONSTANT.PREORDER_RESET_SEATS)
    }
    next()
  },
}
</script>
<style lang="less" scoped>
@import '../../../stylesheet/variable.less';

.schedule {
  position: relative;
  min-height: calc(100vh - 44px);
  .action-container {
    position: fixed;
    bottom: 45px;
    left: 0;
    right: 0;
    background-color: #f4f4f4;
    padding: 10px;
    z-index: 2;
  }
  .input-wrap {
    border-radius: 4px;
    padding: 0 15px;
    background: #fff;
    z-index: 4;
    .realname-box {
      display: flex;
      align-items: center;
      font-size: 13px;
      height: 49px;
      position: relative;
      &::after {
        .setBottomLine(#ededed);
      }
      img {
        width: 14px;
        height: 14px;
      }
      .title {
        margin-left: 4px;
        color: #ff5f16;
        flex-grow: 3;
      }
      .title-done {
        margin-left: 4px;
        color: #191a1b;
      }
      .need {
        color: #bdc0c5;
        margin-right: 4px;
      }
      .need-done {
        color: #191a1b;
        margin-left: auto;
      }
    }
  }
  .notice-padding {
    height: 44px;
  }

  .cinema-wrap {
    .cinema-info {
      position: relative;
      padding: 15px 0 10px;

      .film-name {
        color: #191a1b;
        font-size: 15px;
        line-height: 21px;
      }
      .film-des {
        font-size: 13px;
        line-height: 19px;
        margin-top: 4px;
        color: @steelGrey;
      }
      .film-limit {
        font-size: 11px;
        color: @reddish;
      }
      .switch {
        position: absolute;
        top: 15px;
        right: 0;
        line-height: 20px;
        color: #ff5f16;
        font-size: 13px;
      }

      .arrow {
        width: 12px;
        height: 7px;
        padding-bottom: 2px;
      }
    }
  }
}
</style>

<style lang="less">
.mint-msgbox-message {
  line-height: 22.5px;
}
</style>
